import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useMsal } from '@azure/msal-react';
import * as TeamsState from '../../store/TeamsState';
import { useTranslation } from 'react-i18next';
import { TokenHelper } from '../../TokenHelper';
import { SortHelper } from '../../SortHelper';
import { Consultant, ConsultantInvoice } from '../../interfaces/Consultant';
import { ConsultantActionCreators } from '../../store/consultants';
import { dataActionCreators } from '../../store/Data';
import { Accordion, AccordionHeader, AccordionItem, AccordionItemValue, AccordionPanel, AccordionToggleEventHandler, Button, Divider, InputOnChangeData, Popover, PopoverSurface, PopoverTrigger, SearchBox, SearchBoxChangeEvent, Table, TableBody, TableCell, TableCellActions, TableCellLayout, TableHeader, TableHeaderCell, TableRow, Tag } from '@fluentui/react-components';
import { DownloadFileAndSave, DownloadSPOLinkAndNav } from '../Tools/FileDownloadHelper';
import { SharePointSVG } from '../Resources/SharePointSVG';
import { Text } from '@fluentui/react-components';
import { AddIcon, ArrowClockwiseIcon, DownloadIcon, EditIcon, FilterIcon, UploadIcon, useEditorStyles, useTabStyles } from '../Styles/Editor';
import { ConsultantDropdown } from '../EditorHelpers/ConsultantDropdown';
import { useState } from 'react';
import { useRigths, useConsultants, useConsultantsInvoices } from '../Tools/ObjectLoader';

interface ConsultantsinvoicesMonth {
    key: AccordionItemValue;
    docs: ConsultantInvoice[];
    year: number;
    month: number;
}

export const ConsultantsInvoicesTab = () => {
    const { consultants } = useConsultants();
    const { consultantsInvoices } = useConsultantsInvoices();
    const [filter, setFilter] = useState<string | null>(null);
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const { t } = useTranslation();
    const teamsState = useSelector<ApplicationState, TeamsState.TeamsState>((state: ApplicationState) => state.teamsState);
    const { isAdmin } = useRigths();
    const [filterConsultant, setFilterConsultant] = useState<Consultant | undefined>(undefined);
    const stylesTab = useTabStyles();
    const styles = useEditorStyles();
    const [consultantsInvoicesFilter, setConsultantsInvoicesFilter] = useState<ConsultantsinvoicesMonth[]>([]);
    const [defaultOpenItems, setdefaultOpenItems] = useState<AccordionItemValue[]>([]);

    React.useEffect(() => {
        if (consultantsInvoices != undefined) {
            let filteredInvoices = consultantsInvoices;
            // Apply filter if any
            if (filterConsultant) {
                filteredInvoices = filteredInvoices
                    .filter(i => (i.consultantid === filterConsultant.consultantid));
            }
            if (filter && filter.length != 0) {
                filteredInvoices = filteredInvoices
                    .filter(i => i.invoiceRef && i.invoiceRef.toLowerCase().includes(filter.toLowerCase()));
            }

            const invs = filteredInvoices.sort(SortHelper.ConsultantInvoiceByPeriode_Desc);
            let LastYear = -1;
            let LastMonth = -1;
            let open = false;
            const DocDone: ConsultantsinvoicesMonth[] = [];
            const DefOpen: AccordionItemValue[] = [];
            let DocDoneCurrent: ConsultantsinvoicesMonth | null = null;
            let counter = isAdmin ? 2 : 12;

            invs.forEach((i) => {
                const dd = i.periode ? new Date(i.periode) : new Date();
                if (dd.getFullYear() !== LastYear || dd.getMonth() != LastMonth) {
                    if ((open || counter > 0) && DocDoneCurrent) {
                        counter--;
                        DefOpen.push(DocDoneCurrent.key);
                    }
                    LastYear = dd.getFullYear();
                    LastMonth = dd.getMonth();
                    open = false;
                    if (DocDoneCurrent) {
                        DocDone.push(DocDoneCurrent);
                    }
                    DocDoneCurrent = {
                        key: "ConsultantInvoices" + (LastMonth + 1) + "/" + LastYear, year: LastYear, month: LastMonth + 1, docs: []
                    };
                }

                if (DocDoneCurrent !== null) {
                    DocDoneCurrent.docs.push(i);
                }
                if (i.paymentDate == null) {
                    open = true;
                }
            });
            if (DocDoneCurrent) {
                DocDone.push(DocDoneCurrent);
            }
            setConsultantsInvoicesFilter(DocDone);
            setdefaultOpenItems(DefOpen);
        }
    }, [consultantsInvoices, filter, filterConsultant]);

    const columns = isAdmin ?
        [
            { columnKey: "Consultant", label: t('Consultant'), className: stylesTab.width17 },
            { columnKey: "Invoices", label: t('Invoices'), className: stylesTab.width17 },
            { columnKey: "Status", label: "Status", className: stylesTab.width17 },
            { columnKey: "Billed", label: t('Billed') + " (" + t('ExcludVAT') + ")", className: stylesTab.width17 },
        ]
        :
        [
            { columnKey: "Invoices", label: t('Invoices'), className: stylesTab.width17 },
            { columnKey: "Status", label: "Status", className: stylesTab.width17 },
            { columnKey: "Billed", label: t('Billed') + " (" + t('ExcludVAT') + ")", className: stylesTab.width17 },
        ]
        ;

    const mapInvoice = (i: ConsultantInvoice): JSX.Element => {
        const co = consultants ? consultants.find(x => x.consultantid === i.consultantid) : undefined;
        let InvoiceStatus = <Text className={stylesTab.InlineCenteredDangerText}>{t('NotInvoiced2Customer')}</Text>;
        if (i.paymentDate) {
            InvoiceStatus = <Text className={stylesTab.InlineCenteredSuccessText}>{t('Paid')}</Text>;
        }
        else if (i.lock) {
            InvoiceStatus = <Text className={stylesTab.InlineCenteredWarningText}>{t('InProcess')}</Text>;
        }
        return <TableRow key={i.consultantInvoiceid}>
            {isAdmin &&
                <TableCell>
                    <Button appearance="transparent" className={stylesTab.TestButton}
                        onClick={() => dispatch(ConsultantActionCreators.requestConslutantQuickView(co ? co : null))}>
                        {co ? co.displayName : ""}
                    </Button>
                </TableCell>
            }
            <TableCell>
                <TableCellLayout>
                    <Button appearance="transparent" className={stylesTab.TestButton}
                        onClick={() => dispatch(dataActionCreators.requestInvoiceQuickView(null))}>
                        {i.invoiceRef}
                    </Button>
                </TableCellLayout>
                <TableCellActions>
                    {i.invoiceFileExist
                        ? <>
                            <Button
                                icon={<DownloadIcon />}
                                appearance="subtle"
                                aria-label="Download"
                                onClick={() => {
                                    TokenHelper.GetToken(instance, teamsState)
                                        .then(token => {
                                            if (token !== null && i.consultantInvoiceid) {
                                                DownloadFileAndSave('api/ConsultantsInvoices/' + i.consultantInvoiceid + "/DownloadSPOLink", token);
                                            }
                                        });
                                }
                                } />
                            {isAdmin &&
                                <Button
                                    icon={<SharePointSVG />}
                                    appearance="subtle"
                                    aria-label={t('ViewInSharePoint')}
                                    onClick={() => {
                                        TokenHelper.GetToken(instance, teamsState)
                                            .then(token => {
                                                if (token !== null && i.consultantInvoiceid) {
                                                    DownloadSPOLinkAndNav('api/ConsultantsInvoices/' + i.consultantInvoiceid + "/DownloadSPOLink", token);
                                                }
                                            });
                                    }
                                    } />}
                        </>
                        : <Text className={stylesTab.InlineCenteredDangerText}>{t('Missing')}</Text>
                    }
                    {(!i.lock && i.paymentDate === null) &&
                        <Button
                            icon={<UploadIcon />}
                            appearance="subtle"
                            aria-label="Upload"
                            onClick={() => dispatch(dataActionCreators.requestFileUploadConsultantInvoice(i))} />}
                    {((!i.lock && i.paymentDate === null) || isAdmin) &&
                        <Button
                            icon={<EditIcon />}
                            appearance="subtle"
                            aria-label={t('Edit')}
                            onClick={() => dispatch(ConsultantActionCreators.requestConsultantInvoiceEdition(i))} />}
                </TableCellActions>
            </TableCell>
            <TableCell>
                {InvoiceStatus}
            </TableCell>
            <TableCell>
                <Text>{i.amount.toLocaleString(undefined, { style: 'currency', currency: 'EUR' })}</Text>
            </TableCell>
        </TableRow>;
    };

    const handleToggle: AccordionToggleEventHandler<AccordionItemValue> = (event, data) => {
        setdefaultOpenItems(data.openItems);
    };
    return <div className={stylesTab.rootSub}>
        <div className={stylesTab.MainBar}>
            {isAdmin &&
                <Popover positioning="below-start">
                    <PopoverTrigger>
                        <Button icon={<FilterIcon />} shape="circular" title="Filter" />
                    </PopoverTrigger>
                    <PopoverSurface>
                        <div className={stylesTab.List}>
                            {t('Consultant')}
                            <ConsultantDropdown
                                currentConsultant={filterConsultant}
                                setConsultant={setFilterConsultant}
                            />
                        </div>
                    </PopoverSurface>
                </Popover>
            }
            {filterConsultant &&
                <Tag
                    dismissible
                    dismissIcon={{ "aria-label": "remove" }}
                    size="small"
                    onClick={() => { setFilterConsultant(undefined); }}
                    appearance="outline"
                >
                    {t('Consultant') + " = " + filterConsultant.displayName}
                </Tag>}
            <SearchBox
                placeholder={t('Contains')}
                onChange={(e: SearchBoxChangeEvent, data: InputOnChangeData) => { setFilter(data.value); }}
                dismiss={{ onClick: () => { setFilter(null); } }}
                className={styles.fluid}
            />
            <div className={stylesTab.MarginLeftAuto}>
                <Button icon={<AddIcon />} shape="circular" title={t('Add')} onClick={() => {
                    const p: ConsultantInvoice = {
                        consultantInvoiceid: null,
                        consultantid: null,
                        invoiceRef: null,
                        creationDate: null,
                        periode: null,
                        sharePointFileUniqueId: null,
                        invoiceFileExist: false,
                        paymentDate: null,
                        amount: 0,
                        description: null,
                        lock: false,
                        vatcode: 21,
                        accountingRef: null,
                        documentDate: null,
                    };
                    dispatch(ConsultantActionCreators.requestConsultantInvoiceEdition(p));
                }} />
                <Button icon={<ArrowClockwiseIcon />} shape="circular" title="Reload" onClick={() => {
                    dispatch(ConsultantActionCreators.ReloadConsultantsInvoices());
                }} />
            </div>
        </div>
        <h2>{t('Invoices')}</h2>
        <Accordion multiple collapsible openItems={defaultOpenItems} onToggle={handleToggle}>
            {consultantsInvoicesFilter.filter((cds) => cds.docs.length > 0).map((cds) => {
                return <AccordionItem value={cds.key} >
                    <AccordionHeader><Divider appearance="brand">{(cds.month) + "/" + cds.year}</Divider></AccordionHeader>
                    <AccordionPanel>
                        <Table arial-label="Default table">
                            <TableHeader>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableHeaderCell key={column.columnKey} className={column.className}>
                                            {column.label}
                                        </TableHeaderCell>
                                    ))}
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {cds.docs.map(p => mapInvoice(p))}
                            </TableBody>
                        </Table>
                    </AccordionPanel>
                </AccordionItem>;
            })}
        </Accordion>
    </div>;
};